import userUtils from 'app/shared/utils/userUtils';

const CompanyUser = ({
    userName = '',
    email = '',
    userToken = '',
    userBrand = '',
    roles = [],
    propertyCount = 0,
    isCurrentUser = false,
    isPending = false,
    isAdmin = false,
    isPendingDelete = false,
    isPendingEdit = false,
    lastActivityTimestamp = '',
} = {}) => ({
    userName: userName ? String(userName) : String(email).split('@')[0],
    email: String(email),
    userToken: String(userToken),
    userBrand: String(userBrand),
    permissions: userUtils.getFeaturePermissions(roles),
    propertyCount: Number(propertyCount),
    isCurrentUser: Boolean(isCurrentUser),
    isPending: Boolean(isPending),
    isAdmin: Boolean(isAdmin),
    isPendingDelete: Boolean(isPendingDelete),
    isPendingEdit: Boolean(isPendingEdit),
    lastActivityTimestamp: String(lastActivityTimestamp),
});

export default CompanyUser;
